import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import VehicleServics from "../../../services/VehicleServics";
import Swal from "sweetalert2";
import AssignDriver from "./AssignDriver";

const VechileDetailsWithDriver = () => {
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [gridInsideModal, setGridInsideModal] = useState(false);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [statusFilter, setStatusFilter] = useState("");
    const [typeFilter, setTypeFilter] = useState("");

    const [searchQuery, setSearchQuery] = useState("");

    const user = JSON.parse(localStorage.getItem("userDetails"));
    const availableStores = user?.data?.user?.store || [];
    const defaultStore = availableStores[0]?._id || "";

    const [stores] = useState(availableStores);
    const [selectedStore, setSelectedStore] = useState(defaultStore);

    const [selectedItem, setSelectedItem] = useState();

    const sort = 50;
    const activePag = useRef(0);

    // ✅ API CALL ON SUBMIT
    // ✅ API CALL ON SUBMIT
    const handleFilterSubmit = async () => {
        try {
            setLoading(true);

            const res = await VehicleServics.getVehicleByStatus({
                status: statusFilter === "" ? undefined : statusFilter === "true",
                rentalStatus: typeFilter || undefined,
                includeDrivers: true   // ✅ ADD THIS
            });

            // ✅ FIX: correct data path
            setData(res?.data || []);

        } catch (error) {
            Swal.fire("Error", "Failed to fetch vehicles", "error");
        } finally {
            setLoading(false); // ✅ always stop loader
        }
    };



    return (
        <>


            <div className="row">
                <div className="col-xl-12">

                    {/* 🔍 FILTER SECTION */}
                    <div className="filter cm-content-box box-primary">
                        <div className="content-title">
                            <div className="cpa">
                                <i className="fas fa-filter me-2"></i>Filter
                            </div>
                            <div className="tools">
                                <Link to={"#"} onClick={() => setOpen(!open)}>
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>

                        <Collapse in={open}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">
                                    <div className="row align-items-end g-2">

                                        {/* Status */}
                                        <div className="col-xl-4">
                                            <label className="form-label mb-1">Status</label>
                                            <select
                                                className="form-select"
                                                value={statusFilter}
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                style={{ height: "38px" }}
                                            >
                                                <option value="">All</option>
                                                <option value="true">Active</option>
                                                <option value="false">Inactive</option>
                                            </select>
                                        </div>

                                        {/* Type */}
                                        <div className="col-xl-4">
                                            <label className="form-label mb-1">Type</label>
                                            <select
                                                className="form-select"
                                                value={typeFilter}
                                                onChange={(e) => setTypeFilter(e.target.value)}
                                                style={{ height: "38px" }}
                                            >
                                                <option value="">All</option>
                                                <option value="Purchased">Purchased</option>
                                                <option value="Rented">Rented</option>
                                            </select>
                                        </div>

                                        {/* Button */}
                                        <div className="col-xl-4">
                                            <button
                                                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                                                style={{ height: "38px", borderRadius: "6px" }}
                                                onClick={handleFilterSubmit}
                                            >
                                                Submit
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>

                    {/* 📊 TABLE SECTION */}
                    <div className="filter cm-content-box box-primary">
                        <div className="content-title">
                            <div className="cpa">
                                <i className="fa fa-list me-2"></i>
                                Vehicle List <span className="badge bg-orange ms-2">{data.length}</span>
                            </div>
                        </div>

                        <Collapse in={open2}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">

                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Name</th>
                                                    <th>Driver</th>
                                                    <th>Category</th>
                                                    <th>Store</th>
                                                    <th>Capacity</th>
                                                    <th>Average</th>
                                                    <th>Status</th>
                                                    <th>Requisition</th>

                                                </tr>
                                            </thead>

                                            <tbody>
                                                {data.length > 0 ? (
                                                    data.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td className="scrollable-description">{item.name}</td>
                                                            <td className="scrollable-description">
                                                                {item?.assignedDrivers && item.assignedDrivers.length > 0 ? (
                                                                    item.assignedDrivers.map((d, index) => {

                                                                        const vehicleStoreName = item?.assignedStore?.name;

                                                                        const stores = d?.storeDetails
                                                                            ?.map(s => s?.name)
                                                                            .filter(Boolean);

                                                                        // ✅ Check match
                                                                        const isMatched = stores?.some(
                                                                            s => s?.toLowerCase() === vehicleStoreName?.toLowerCase()
                                                                        );

                                                                        return (
                                                                            <div key={index} style={{ marginBottom: "8px" }}>

                                                                                {/* Driver Name (RED if not matched) */}
                                                                                <div style={{ color: isMatched ? "inherit" : "red", fontWeight: isMatched ? "normal" : "800" }}>
                                                                                    {index + 1}. {d?.name || "N/A"}
                                                                                </div>

                                                                                {/* Store List */}
                                                                                {stores && stores.length > 0 && (
                                                                                    <div style={{ paddingLeft: "15px", fontSize: "13px" }}>
                                                                                        <div>Stores:</div>
                                                                                        {stores.map((store, i) => (
                                                                                            <div key={i}>- {store}</div>
                                                                                        ))}
                                                                                    </div>
                                                                                )}

                                                                            </div>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    "No Driver"
                                                                )}
                                                            </td>
                                                            <td>{item?.category?.name}</td>
                                                            <td className="scrollable-description">{item?.assignedStore?.name}</td>
                                                            <td>{item.capacity}</td>
                                                            <td>{item.average}</td>
                                                            <td>{item.rentalStatus}</td>
                                                            <td className="text-center"><i className="bi bi-plus"></i></td>

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9">No Data Found</td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    </div>

                                </div>
                            </div>
                        </Collapse>
                    </div>

                </div>
            </div>
        </>
    );
};

export default VechileDetailsWithDriver;